import { useEffect, useState } from 'react';

export const useInViewActive = (ref, threshold = 0.05) => {
  const [active, setActive] = useState(true);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => setActive(e.isIntersecting && !document.hidden), { threshold });
    io.observe(el);
    const onVis = () => setActive(!document.hidden);
    document.addEventListener('visibilitychange', onVis);
    return () => { io.disconnect(); document.removeEventListener('visibilitychange', onVis); };
  }, [ref, threshold]);
  return active;
};

export default useInViewActive;
